import { type GetExamSessionQueryResponse } from '@exam-room/graphql';
import { useCallback, useMemo } from 'react';

import { ExamSessionContext as ExamPreviewSessionContext } from '../exam-session';
import { useNewExam } from '../new-exam';

import { generateExamSession } from './utils';

type ExamSession = GetExamSessionQueryResponse['erGetExamSessionAnswer'];

interface ExamPreviewSessionProviderProps {
  children: React.ReactNode;
}

function ExamPreviewSessionProvider({ children }: Readonly<ExamPreviewSessionProviderProps>) {
  const { examPaper } = useNewExam();

  const examSession = useMemo(() => generateExamSession(examPaper) as ExamSession, [examPaper]);

  const refetch = useCallback(async () => {
    // Preview mode doesn't need refetch functionality
  }, []);

  const contextValue = useMemo(
    () => ({
      examSession,
      loading: false,
      error: undefined,
      refetch,
    }),
    [examSession, refetch],
  );

  return (
    <ExamPreviewSessionContext.Provider value={contextValue}>
      {children}
    </ExamPreviewSessionContext.Provider>
  );
}

export { ExamPreviewSessionProvider };
